import React from "react";
import {Controller, ControllerProps, useController} from "react-hook-form";

import {ToggleButton} from "@pg-design/button-module";
import {ToggleButtonProps} from "@pg-design/button-module";

type IProps<FormValues extends object> = Omit<ControllerProps<FormValues>, "render" | "value"> & {} & Omit<ToggleButtonProps, "checked" | "onChange" | "name">;

/*
    Label scenarios - provide aria-labelledby if you're not providing a labelContent
 */

export function ToggleButtonControlled<FormValues extends object>(props: IProps<FormValues>) {
    const {name, defaultValue, control, onClick, ...inputProps} = props;
    const fieldController = useController<FormValues>({control, name});

    if (!fieldController) {
        throw new Error(
            "ToggleButtonControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider or provide an optional 'control' prop"
        );
    }

    const {
        field: {onChange, value}
    } = fieldController;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({field}) => (
                <ToggleButton
                    {...field}
                    {...inputProps}
                    isActive={value}
                    onClick={() => {
                        onClick?.(!value);
                        onChange(!value);
                    }}
                />
            )}
        />
    );
}
import React from "react";
import {Controller, ControllerProps, useController} from "react-hook-form";

import {ToggleButton} from "@pg-design/button-module";
import {ToggleButtonProps} from "@pg-design/button-module";

type IProps<FormValues extends object> = Omit<ControllerProps<FormValues>, "render" | "value"> & {} & Omit<ToggleButtonProps, "checked" | "onChange" | "name">;

/*
    Label scenarios - provide aria-labelledby if you're not providing a labelContent
 */

export function ToggleButtonControlled<FormValues extends object>(props: IProps<FormValues>) {
    const {name, defaultValue, control, onClick, ...inputProps} = props;
    const fieldController = useController<FormValues>({control, name});

    if (!fieldController) {
        throw new Error(
            "ToggleButtonControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider or provide an optional 'control' prop"
        );
    }

    const {
        field: {onChange, value}
    } = fieldController;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({field}) => (
                <ToggleButton
                    {...field}
                    {...inputProps}
                    isActive={value}
                    onClick={() => {
                        onClick?.(!value);
                        onChange(!value);
                    }}
                />
            )}
        />
    );
}
